import CONSTANTS from '../constants'
import { getRequest } from '../../services'
import { APICONFIG } from '../config/apiConfig'
import { addEventLog } from '../../pages/warningCitation/redux/actions/EventsLog'

//PARKING TYPES FETCHING API
export const getParkingTypes = () => async (dispatch) => {
    const payload = {
        device_type :' web'
    }
    dispatch(addEventLog(payload, CONSTANTS.GET_PARKING_TYPES_REQUEST))
	dispatch({ type: CONSTANTS.GET_PARKING_TYPES_REQUEST })
    
	return getRequest(`${APICONFIG.getParkingTypeUrl}`).then((res) => {
        let resObject = { ...payload, ...res }
        dispatch(addEventLog(resObject, CONSTANTS.GET_PARKING_TYPES_SUCCESS))
		dispatch({ type: CONSTANTS.GET_PARKING_TYPES_SUCCESS, data: res?.data })
		return res?.data
	}).catch((error) => {
        let errObject = { ...payload, ...error }
        dispatch(addEventLog(errObject, CONSTANTS.GET_PARKING_TYPES_FAILURE))
		dispatch({ type: CONSTANTS.GET_PARKING_TYPES_FAILURE, errorMessage : error?.errors?.message})
		return error
	})
}

//FETCH VALIDATION CODES
export const getValidationCodes = () => async (dispatch) => {
    const payload = {
        device_type :' web'
    }
    dispatch(addEventLog(payload, CONSTANTS.GET_VALIDATION_CODES_REQUEST))
	dispatch({ type: CONSTANTS.GET_VALIDATION_CODES_REQUEST })
    
	return getRequest(`${APICONFIG.getValidationCodesUrl}`).then((res) => {
        let resObject = { ...payload, ...res }
        dispatch(addEventLog(resObject, CONSTANTS.GET_VALIDATION_CODES_SUCCESS))
		dispatch({ type: CONSTANTS.GET_VALIDATION_CODES_SUCCESS, data: res?.data })
		return res?.data
	}).catch((error) => {
        let errObject = { ...payload, ...error }
        dispatch(addEventLog(errObject, CONSTANTS.GET_VALIDATION_CODES_FAILURE))
		dispatch({ type: CONSTANTS.GET_VALIDATION_CODES_FAILURE, errorMessage : error?.errors?.message})
		return error
	})
}

// FIND RESERVATION BY BOOKING NUMBER
export const searchReservation = (payload) => async (dispatch) => {
    const logPayload = {
        ...payload, 
        device_type :' web'
    }

    let apiEndPoint = `${APICONFIG.findReservationApi}`

    if(payload?.reservation_id){
        apiEndPoint = `${apiEndPoint}/${payload?.reservation_id}`
    }
    if(payload?.email){
        apiEndPoint = `${apiEndPoint}/${payload?.email}`
    }

    dispatch(addEventLog(logPayload, CONSTANTS.GET_FIND_RESERVATION_REQUEST))
	dispatch({ type: CONSTANTS.GET_FIND_RESERVATION_REQUEST })
    
	return getRequest(apiEndPoint).then((res) => {
        let resObject = { ...logPayload, ...res }
        dispatch(addEventLog(resObject, CONSTANTS.GET_FIND_RESERVATION_SUCCESS))
		dispatch({ type: CONSTANTS.GET_FIND_RESERVATION_SUCCESS, data: res?.data })
        return res?.data
	}).catch((error) => {
        let errObject = { ...logPayload, ...error }
        dispatch(addEventLog(errObject, CONSTANTS.GET_FIND_RESERVATION_FAILURE))
		dispatch({ type: CONSTANTS.GET_FIND_RESERVATION_FAILURE, errorMessage : error?.errors?.message})
		return error
	})
}